import { fetchImports } from './fetch-imports';
import { useQuery } from 'react-query';

function useImports(accountId, options) {
  const queryKey = ['IMPORTS', { accountId }];
  return useQuery(queryKey, () => fetchImports(accountId), options);
}

export { useImports };
